import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: '30 Clases Express',
    desc: '30 clases de 25-35 min, sin equipamiento, en 2×2 metros. Abrís la ficha y la clase funciona.',
    value: 'USD 8'
  }, {
    num: '02',
    title: 'Juegos y Dinámicas Grupales',
    desc: '50 juegos y dinámicas para que tus alumnos se diviertan, se conecten y no abandonen nunca.',
    value: 'USD 10'
  }, {
    num: '03',
    title: 'Planificación Mensual Lista',
    desc: '12 sesiones del mes con ejercicios, tiempos, cargas y progresión. Copiá, aplicá y liderá.',
    value: 'USD 7'
  }, {
    num: '04',
    title: 'Adaptación por Tipo de Alumno',
    desc: 'Protocolos para sobrepeso, adultos mayores 60+ y principiantes extremos. Progresión de 12 semanas.',
    value: 'USD 6'
  }];
  return <section className="py-6 md:py-10 px-4 bg-brand-card border-y border-white/5" data-id="element-55">
      <div className="max-w-4xl mx-auto" data-id="element-56">
        <div className="text-center mb-6" data-id="element-57">
          <div className="inline-flex items-center justify-center bg-brand-accent text-brand-dark font-black px-3 py-1 rounded-full mb-2 text-xs shadow-[0_0_15px_rgba(200,255,0,0.3)] uppercase tracking-wider" data-id="element-58">
            <Gift className="w-3.5 h-3.5 mr-1.5" data-id="element-59" />
            Incluidos sin costo extra
          </div>
          <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-tight" data-id="element-60">
            🎁 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-6" data-id="element-61">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-dark rounded-xl p-4 border border-white/5 hover:border-brand-accent/50 transition-colors relative overflow-hidden group" data-id="element-62">
              <div className="flex items-start mb-2" data-id="element-63">
                <div className="bg-brand-accent text-brand-dark font-black text-sm w-8 h-8 rounded-lg flex items-center justify-center mr-3 shrink-0" data-id="element-64">
                  {bonus.num}
                </div>
                <div className="flex-1" data-id="element-65">
                  <h3 className="text-base font-black leading-tight text-white mb-1" data-id="element-66">
                    {bonus.title}
                  </h3>
                  <p className="text-xs text-gray-400 leading-snug font-medium" data-id="element-67">
                    {bonus.desc}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between border-t border-white/10 pt-2 mt-2" data-id="element-68">
                <span className="text-gray-600 line-through font-bold text-xs" data-id="element-69">
                  {bonus.value}
                </span>
                <span className="text-brand-dark font-black text-xs bg-brand-accent px-2 py-0.5 rounded" data-id="element-70">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-dark rounded-xl p-3 text-center border border-brand-accent/30 max-w-md mx-auto" data-id="element-71">
          <p className="text-sm font-bold text-gray-400" data-id="element-72">
            Valor total:{' '}
            <span className="line-through text-gray-600" data-id="element-73">USD 31</span>{' '}
            <span className="text-brand-accent font-black neon-glow" data-id="element-74">
              → GRATIS
            </span>
          </p>
        </div>
      </div>
    </section>;
}